<template>
	<div class="title" @click="$emit('click')">
		<div :style="`background: #${bg};font-weight: ${weight};font-size: ${size}px;color: #${color};`">
			<span style="margin-bottom: 2px">
				<slot name="icon" />
			</span>
			<span>
				<slot/>
			</span>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			bg:{
				type: String,
				default: 'FF9900'
			},
			color:{
				type: String,
				default: '000'
			},
			weight: {
				type: String,
				default: 'normal'
			},
			size: {
				type: String,
				default: '26'
			}
		}
	}
</script>

<style lang="scss">
	.title{
		display: flex;
		width: 100%;
		justify-content: center;
		margin-bottom: 60px;
		div{
			padding: 10px 10px 1px 5px;
			clip-path: polygon(0 0, 97% 15%, 100% 100%, 0% 100%);
			display: flex;
			align-items: center;
		}
	}
</style>
